import React from "react";
import { useMediaQuery } from "react-responsive";
import "../styles/ImgStart.scss";
import logo from "../images/logo3.png";

const ImgStart = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  return (
    <>
      {isMobile && (
        <div className="container imgLogoContainer">
          <img src={logo} alt="Logo High Life Language School  Clases de Inglés" />
        </div>
      )}
    </>
  );
};

export default ImgStart;
